/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?2d869d7ab7d56ac3052db866';
import '@vendor/wowjs/dist/wow.min.js?2d869d7ab7d56ac3052db866';

u.importCSS('@vendor/animate.css/animate.min.css');

$(() => {
  if (!$('body').hasClass('module-lyrasoft-luna-module-front-page')) {
    new WOW().init();
  }
})

u.use(UIBootstrap5);

export default u;

alertify.set('notifier', 'position', 'top-right');

u.notify = function (message, type = 'primary', options = {}) {
  return alertify.notify(message, type, options.wait || 5, options.callback || null);
};

const fontBtn = $('.j-switch__btn');
const copyBtn = $('.j-copy-link');

fontBtn.on('click', (e) => {
  const $this = $(e.currentTarget);
  const wrapper = $this.parent();

  wrapper.find('.j-switch__btn').removeClass('active');

  $('body').css('font-size', $this.data('target'));

  $this.addClass('active');
});

copyBtn.on('click', () => {
  navigator.clipboard.writeText(window.location.href);

  u.notify('連結已複製')
});

$(() => {
  setTimeout(() => {
    $('body').removeClass('h-no-transitions');
  }, 1000);
});
